import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { BillingService } from '../services/billing.service';

@Injectable({
  providedIn: 'root'
})
export class BillingGuardService implements CanActivate {
  constructor(
    private router: Router,
    private $auth: AuthService,
    private $billing: BillingService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, route: RouterStateSnapshot) {
    return this.$auth.organization$.pipe(
      map(org => {
        if (!org) {
          return false;
        }

        return this.$billing.hasGoodBillingStatus(org);
      }),
      tap(canAccess => {
        if (!canAccess) {
          this.router.navigate(['billing/gate'], {
            queryParams: {
              returnUrl: route.url
            }
          });
        } else {
          console.log(`[BillingGuardService] canActivate true, allowing access to ${route.url}`);
        }
      })
    );
  }
}
